import axios from "axios"
import Paginations from "components/Common/Pagination"
import { API_URL } from "components/Common/Utils"
import Filters from "components/Shared/Filters"
import IsLoading from "components/Shared/IsLoading"
import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Button, Table } from "reactstrap"
import { getMatchedCandidatesList } from "store/actions/interviewsAction"
import { showAlert } from "store/reducers/alertReducer"

const MatchedCandidates = ({
  values,
  selectedCandidates,
  setSelectedCandidates,
  selectAllPages,
  setSelectAllPages,
  selectCurrentPage,
  setSelectCurrentPage,
  uncheckedIds,
  setUncheckedIds,
  showAll,
  permissions,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()
  const {
    loading2,
    matchedCandidatesList,
    totalCount,
    perPage,
    totalPages,
    currentPage,
  } = useSelector(state => state.Interviews)
  const { dropdownData } = useSelector(state => state.Common)

  const [isExporting, setIsExporting] = useState(false)

  const [filtersState, setFiltersState] = useState({
    searchKeyword: "",
  })

  const [isShowFilter, setIsShowFilter] = useState(false)
  const [trigger, setTrigger] = useState(false)

  const toggleFilterVisibility = () => {
    setIsShowFilter(!isShowFilter)
  }

  useEffect(() => {
    getAllData()
  }, [trigger])

  const getAllData = (page, isReset = false) => {
    const { searchKeyword } = filtersState
    const {
      city_ids,
      specialization_id,
      gender,
      is_saudi,
      education_qualification_id,
      employee_experience,
      employee_experience_as_per_document,
      national_ids,
      minAge,
      maxAge,
      specialization_ids,
      education_qualification_ids,
      nationality_ids,
      positions_ids,
    } = values
    const updatedCitiesId = city_ids?.map(item => item.value) || []
    const updatedSpecializationId =
      specialization_ids?.map(item => item.value) || []
    const updatedEducationQualificationId =
      education_qualification_ids?.map(item => item.value) || []
    const updatedNationalityId = nationality_ids?.map(item => item.value) || []
    const updatedPositionsId = positions_ids?.map(item => item.value) || []

    const nationalIdArray = [
      ...new Set(
        national_ids
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "") // Remove empty strings
      ),
    ]

    // IF HAVE nationalIdArray then add in selectedN
    if (nationalIdArray?.length > 0) {
      setSelectedCandidates(nationalIdArray)
      // setSelectAllPages(false)
    }

    let ageGroup = null
    if (minAge && maxAge) {
      ageGroup = { min: Number(minAge), max: Number(maxAge) }
    }
    let data = {
      limit: perPage,
      page_number: page || 1,
      order_by: 1,
      filters: {
        city_ids: updatedCitiesId,
        specialization_id,
        gender: gender,
        is_saudi,
        education_qualification_id,
        employee_experience: employee_experience,
        employee_experience_as_per_document,
        national_ids: nationalIdArray,
        keyword: isReset ? "" : searchKeyword,
        specialization_ids: updatedSpecializationId,
        education_qualification_ids: updatedEducationQualificationId,
        nationality_ids: updatedNationalityId,
        position_ids: updatedPositionsId,
      },
    }

    if (ageGroup) {
      data.filters.min_age = ageGroup.min
      data.filters.max_age = ageGroup.max
    }

    dispatch(getMatchedCandidatesList(data))
  }

  const onPageChange = page => {
    getAllData(page)

    setSelectCurrentPage(false)
  }

  const handleExport = async () => {
    const { searchKeyword } = filtersState

    const {
      city_ids,
      specialization_id,
      gender,
      is_saudi,
      education_qualification_id,
      employee_experience,
      employee_experience_as_per_document,
      national_ids,
      minAge,
      maxAge,
      specialization_ids,
      education_qualification_ids,
      nationality_ids,
      positions_ids,
    } = values
    const updatedCitiesId = city_ids?.map(item => item.value) || []
    const updatedSpecializationId =
      specialization_ids?.map(item => item.value) || []
    const updatedEducationQualificationId =
      education_qualification_ids?.map(item => item.value) || []
    const updatedNationalityId = nationality_ids?.map(item => item.value) || []
    const updatedPositionsId = positions_ids?.map(item => item.value) || []

    const nationalIdArray = [
      ...new Set(
        national_ids
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "") // Remove empty strings
      ),
    ]

    try {
      setIsExporting(true)
      const authUserString = localStorage.getItem("authUser")
      const authUser = authUserString ? JSON.parse(authUserString) : null
      const token = authUser?.token

      let ageGroup = null
      if (minAge && maxAge) {
        ageGroup = { min: Number(minAge), max: Number(maxAge) }
      }

      let payload = {
        export_type: "search_application",
        filters: {
          city_ids: updatedCitiesId,
          specialization_id,
          gender: gender.value,
          is_saudi,
          education_qualification_id,
          employee_experience: employee_experience.value,
          employee_experience_as_per_document,
          national_ids: nationalIdArray,
          city_ids: updatedCitiesId,
          specialization_id,
          gender: gender.value,
          is_saudi,
          education_qualification_id,
          employee_experience: employee_experience.value,
          employee_experience_as_per_document,
          national_ids: nationalIdArray,
          keyword: searchKeyword,
          specialization_ids: updatedSpecializationId,
          education_qualification_ids: updatedEducationQualificationId,
          nationality_ids: updatedNationalityId,
          position_ids: updatedPositionsId,
          keyword: searchKeyword || "",
        },
      }

      if (ageGroup) {
        payload.filters.min_age = ageGroup.min
        payload.filters.max_age = ageGroup.max
      }

      const response = await axios.post(
        `${API_URL}/api/v1/admin/export/by-type`,
        payload,
        {
          headers: {
            Authorization: token, // Attach token in headers
          },
          responseType: "blob", // Important for file downloads
        }
      )

      const contentType = response.headers["content-type"]

      if (contentType === "application/json") {
        return dispatch(
          showAlert({
            text: t("Export initiated, you will be notified once done."),
            type: "success",
          })
        )
      }

      // Create a URL for the downloaded file
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "export.xlsx") // Set filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url) // Clean up memory
    } catch (error) {
      console.error("Export failed:", error.response?.data || error.message)
    } finally {
      setIsExporting(false)
    }
  }

  const filters = useMemo(() => {
    return {
      searchKeyword: {
        type: "text",
        placeholder: t("Search by name,email,national id or phone number"),
        label: t("Search By"),
        colSize: 4,
      },
      // nationality_ids: {
      //   type: "select",
      //   placeholder: t("Search by nationalities"),
      //   label: t("Nationalities"),
      //   options:
      //     dropdownData?.nationalities?.map(item => ({
      //       label: language === "en" ? item.name : item.name_ar,
      //       value: item.id,
      //     })) || [],
      //   multiple: true,
      //   colSize: 4,
      // },

      // specialization_ids: {
      //   type: "select",
      //   placeholder: t("Search by specialization"),
      //   label: t("Specializations"),
      //   options:
      //     dropdownData?.spacialization?.map(item => ({
      //       label: language === "en" ? item.name : item.name_ar,
      //       value: item.id,
      //     })) || [],
      //   multiple: true,
      //   colSize: 4,
      // },

      // positions_ids: {
      //   type: "select",
      //   placeholder: t("Search by position"),
      //   label: t("Experience Positions"),
      //   options: dropdownData?.job_titles?.map(item => ({
      //     label: language === "en" ? item.name : item.name_ar,
      //     value: item.id,
      //   })),
      //   multiple: true,
      //   colSize: 4,
      // },

      // education_qualification_ids: {
      //   type: "select",
      //   placeholder: t("Search by education qualification"),
      //   label: t("Education Qualifications"),
      //   options:
      //     dropdownData?.education_qualifications?.map(item => ({
      //       label: language === "en" ? item.name : item.name_ar,
      //       value: item.id,
      //     })) || [],
      //   multiple: true,
      //   colSize: 4,
      // },

      // ageGroup: {
      //   type: "numberRange",
      //   minPlaceholder: t("Min Age"),
      //   maxPlaceholder: t("Max Age"),
      //   label: t("Age Range"),
      // },
    }
  }, [t, dropdownData])

  const handleReset = () => {
    setFiltersState({
      searchKeyword: "",
    })
    getAllData(1, true)
  }

  const handleSearch = () => {
    getAllData(1)
  }

  // CHECKBOX FUNCTIONALITY
  // Handle "Select All from Entire Results"
  const handleSelectAllPages = () => {
    setSelectAllPages(!selectAllPages)
    setSelectCurrentPage(false)
    const { national_ids } = values
    if (national_ids?.length > 0) {
      const nationalIdArray = [
        ...new Set(
          national_ids
            .split(",")
            .map(id => id.trim())
            .filter(id => id !== "") // Remove empty strings
        ),
      ]
      if (selectAllPages) {
        setSelectedCandidates([])
      } else {
        setSelectedCandidates(nationalIdArray)
      }
      return
    }
    if (!selectAllPages) {
      // setSelectAllPages(true)
      // setSelectCurrentPage(false)
      setUncheckedIds([]) // Clear unchecked IDs when selecting all
      setSelectedCandidates([]) // Clear selected IDs since we're selecting all
    } else {
      // setSelectAllPages(false)
      setUncheckedIds([])
      setSelectedCandidates([])
    }
  }

  // Handle "Select All from Current Page"
  const handleSelectCurrentPage = () => {
    if (!selectCurrentPage) {
      setSelectCurrentPage(true)
      setSelectAllPages(false)

      // Get all current page IDs
      const currentPageIds = matchedCandidatesList.map(item => item.national_id)

      // Add all current page IDs to the selection
      setSelectedCandidates(prev => [...new Set([...prev, ...currentPageIds])])

      // Reset uncheckedIds from current page
      setUncheckedIds(prev => prev.filter(id => !currentPageIds.includes(id)))
    } else {
      setSelectCurrentPage(false)

      // Remove current page IDs from selection
      const currentPageIds = matchedCandidatesList.map(item => item.national_id)
      setSelectedCandidates(prev =>
        prev.filter(id => !currentPageIds.includes(id))
      )
    }
  }

  // Handle individual candidate selection
  const handleSelectCandidate = national_id => {
    const { national_ids } = values

    const nationalIdArray = [
      ...new Set(
        national_ids
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "") // Remove empty strings
      ),
    ]
    if (nationalIdArray?.length > 0) {
      let newData = []
      if (selectedCandidates.includes(national_id)) {
        newData = selectedCandidates?.filter(id => id !== national_id)
      } else {
        setSelectedCandidates(prev => [...prev, national_id])
        newData = [...selectedCandidates, national_id]
      }
      setSelectedCandidates(newData)
      if (!selectCurrentPage) {
        setSelectAllPages(
          // nationalIdArray?.length === newData?.length ? true : false
          false
        )
      }
      if (selectCurrentPage) {
        setSelectCurrentPage(false)
      }
      return
    }
    // If "Select All Pages" is active
    if (selectAllPages) {
      // Add to unchecked list
      if (!uncheckedIds.includes(national_id)) {
        setUncheckedIds(prev => [...prev, national_id])
      } else {
        // If unchecking an already unchecked ID, remove it from unchecked
        setUncheckedIds(prev => prev.filter(id => id !== national_id))
      }
      return
    }

    // If "Select Current Page" is active
    if (selectCurrentPage) {
      setSelectCurrentPage(false)

      // Get all current page IDs except the one being toggled
      const currentPageIds = matchedCandidatesList.map(item => item.national_id)
      const otherPageIds = selectedCandidates.filter(
        id => !currentPageIds.includes(id)
      )

      // Keep the one being toggled in the selection if it's not already in
      if (!selectedCandidates.includes(national_id)) {
        setSelectedCandidates([...otherPageIds, national_id])
      } else {
        // Otherwise, remove it from selection
        const updatedCurrentPageIds = currentPageIds.filter(
          id => id !== national_id
        )
        setSelectedCandidates([...otherPageIds, ...updatedCurrentPageIds])
      }
      return
    }

    // Normal toggle logic for individual selection
    if (selectedCandidates.includes(national_id)) {
      setSelectedCandidates(prev => prev.filter(id => id !== national_id))
    } else {
      setSelectedCandidates(prev => [...prev, national_id])
    }
  }

  useEffect(() => {
    console.log(selectedCandidates, "Candidate")
    console.log(uncheckedIds)
    console.log(selectAllPages)
    console.log(selectCurrentPage)
  }, [selectedCandidates, uncheckedIds])

  const isCandidateChecked = national_id => {
    const { national_ids } = values
    if (national_ids?.length > 0) {
      if (selectedCandidates.includes(national_id)) {
        return true
      }
      return false
    }
    if (selectAllPages && !uncheckedIds.includes(national_id)) {
      return true
    } else if (
      selectCurrentPage &&
      matchedCandidatesList.some(i => i.national_id === national_id)
    ) {
      return true
    } else if (selectedCandidates.includes(national_id)) {
      return true
    } else {
      return false
    }
  }

  return (
    <div>
      {loading2 ? (
        <IsLoading />
      ) : (
        <div className="table-responsive" style={{ maxHeight: "90vh" }}>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <div className="me-4">
                <input
                  type="checkbox"
                  id="selectAllPages"
                  checked={selectAllPages}
                  onClick={handleSelectAllPages}
                  className="me-2"
                  style={{ height: "unset" }}
                />
                <label htmlFor="selectAllPages" className="mb-0">
                  {t("Select All from Entire Results")}
                </label>
              </div>

              <div>
                <input
                  type="checkbox"
                  id="selectCurrentPage"
                  checked={selectCurrentPage}
                  onClick={handleSelectCurrentPage}
                  className="me-2"
                  style={{ height: "unset" }}
                />
                <label htmlFor="selectCurrentPage" className="mb-0">
                  {t("Select All from Current Page")}
                </label>
              </div>
            </div>
            {matchedCandidatesList?.length > 0 &&
              (showAll ||
                permissions?.includes("enable_view_matching_export")) && (
                <>
                  <Button
                    color="primary"
                    className="px-2"
                    onClick={handleExport}
                    disabled={isExporting}
                  >
                    {t("Download XLSX")}
                  </Button>
                </>
              )}
          </div>
          <Filters
            filters={filters}
            state={filtersState}
            setState={setFiltersState}
            handleReset={handleReset}
            handleSearch={handleSearch}
          />

          {matchedCandidatesList?.length === 0 ? (
            <p className="text-center my-5 fs-4 font-bold">
              {t("No matching data found")}
            </p>
          ) : (
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  <th></th>
                  <th>{t("S. No.")}</th>
                  <th>{t("National Id")}</th>
                  <th>{t("Name")}</th>
                  {/* <th>{t("Email")}</th> */}
                  <th>{t("Phone Number")}</th>
                  <th>{t("Date of Birth")}</th>
                  <th>{t("Gender")}</th>
                  <th>{t("Nationality")}</th>
                  <th>{t("City")}</th>
                  <th>{t("Education Qualification")}</th>
                  <th>{t("Specialization")}</th>
                  <th>{t("Submitted Experience")}</th>
                  <th>{t("System Experience")}</th>
                </tr>
              </thead>
              <tbody>
                {matchedCandidatesList?.map((item, index) => (
                  <tr key={index}>
                    <th>
                      <input
                        type="checkbox"
                        checked={
                          // (selectAllPages &&
                          //   !uncheckedIds.includes(item.national_id)) ||
                          // (selectCurrentPage &&
                          //   matchedCandidatesList
                          //     .map(i => i.national_id)
                          //     .includes(item.national_id)) ||
                          // selectedCandidates.includes(item.national_id)
                          isCandidateChecked(item?.national_id)
                        }
                        onClick={() => handleSelectCandidate(item.national_id)}
                        style={{ height: "unset" }}
                      />
                    </th>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    <td>{item?.national_id}</td>
                    <td>{item?.full_name}</td>
                    {/* <td>{item?.email}</td> */}
                    <td className="ltr fit_content">{item?.phone}</td>
                    <td className="fit_content">{item?.dob}</td>
                    <td className="text-capitalize">{item?.gender}</td>
                    <td>{item?.nationality_name}</td>
                    <td>{item?.city_name}</td>
                    <td>{item?.education_qualification_name}</td>
                    <td>{item?.specialization_name}</td>
                    <td>{item?.submit_experience === 1 ? "Yes" : "No"}</td>
                    <td>{}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          {!loading2 && matchedCandidatesList.length > 0 && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={onPageChange}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default MatchedCandidates
